module.exports = __webpack_public_path__ + "./assets/83aad34b68733f9c42ecdb92df44df5c.svg";